import React from 'react'
import { Link } from "react-router-dom";


const OurDoctor = () => {
    return (
        <>
            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2>Our Doctor</h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}>Our Doctor</li>
                    </ul>
                </div>
            </section>

            <section className="team-section-two" style={{ backgroundImage: 'url(assets/images/background/pattern-13.png)' }}>
                <div className="auto-container">
                    <div className="sec-title centered">
                        <div className="sec-title_title" style={{ marginTop: "-40px" }}>Our Team</div>
                        <h2 className="sec-title_heading">Our specialist team </h2>
                    </div>
                    <div className="row clearfix">

                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="0ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Amrendra Verma.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><Link to="/Dr-av">Dr. Amrendra Verma</Link></h5>
                                        <div className="designation"><b>MBBS, MS, DNB</b></div>
                                        <br />
                                        <br />

                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa-brands fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa-brands fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa-brands fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa-brands fa-linkedin" /></li> */}
                                            <div className="about-one_button">
                                                <Link to="/Dr-av" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>

                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="150ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '150ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Mulayam Singh Yadav.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><Link to="/Dr-msy">Dr. Mulayam Singh Yadav</Link></h5>
                                        <div className="designation"><b>( Gold Medalist)
                                            MBBS, MS Orthopedic, D.Ortho </b></div>

                                        <ul className="social-box">
                                            <li className="facebook" target="_blank"><Link to="https://www.facebook.com/share/1AHhY5eEiH/" className="fa fa-facebook-f" /></li>
                                            <li className="instagram" target="_blank"><Link to="https://www.instagram.com/dr_mulayam__ortho_doctor_satna/?igsh=c3piMjhoOWJ2dW0x#" className="fa fa-instagram" /></li>
                                            <li className="twitter" target="_blank"><Link to="https://www.youtube.com/@drmulayamorthosurgeonenglishch" className="fa fa-youtube" /></li>
                                            {/* <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                                       <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <div className="about-one_button">
                                                <Link to="/Dr-msy" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>

                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="300ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '300ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Rohit Dubey.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><Link to="/dr-rohit-dubey">Dr. Rohit Dubey</Link></h5>
                                        <div className="designation"><b>M.B.B.S, MS, Surgery (MGM Indore) General And Laproscopic Surgeon</b></div>

                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <div className="about-one_button">
                                                <Link to="/dr-rohit-dubey" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>

                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Shruti Shandilya.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><a to="#">Dr. Shruti Shandilya</a></h5>
                                        <div className="designation"><b> MBBS, MS (ENT) </b></div>

                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <br />
                                            <br />
                                            <br />
                                            <div className="about-one_button">
                                                <Link to="/dr-shruti-shandilya" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>
                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Kirti singh.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><a to="#">Dr. Kirti singh</a></h5>
                                        <div className="designation"><b> MBBS, MS
                                            Obstetrics and Gynecologist
                                            IVF, Laparoscopic and Infertility
                                            Specialist </b></div>

                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <br />
                                            <br />
                                            <br />
                                            <div className="about-one_button">
                                                <a to="/about-us" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </a>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>
                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Atul kumar khare.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><a to="#">Dr. Atul kumar khare</a></h5>
                                        <div className="designation"><b> MBBS, MS, MCh, FMAS
                                            General Surgeon
                                            Pediatrics Surgeon
                                            Laparoscopic Surgeon
                                            Pediatrics Urologist </b></div>

                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <br />
                                            <div className="about-one_button">
                                                <a to="/about-us" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </a>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>
                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Wahgurusharan Bhatija.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><Link to="/dr-vahguru-sharan-bathija">Dr. Vahguru Sharan Bathija</Link></h5>
                                        <div className="designation"><b>MBBS, MD (DVL), Dermatologist and Cosmetologist</b></div>

                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <div className="about-one_button">
                                                <Link to="/dr-vahguru-sharan-bathija" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>

                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Divyant Gupta.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><Link to="/dr-divyant-gupta">Dr. Divyant Gupta</Link></h5>
                                        <div className="designation"><b>MBBS, MD Medicine</b></div>
                                        <br />
                                        <br />
                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <div className="about-one_button">
                                                <Link to="/dr-divyant-gupta" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>

                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Savita Patel.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><Link to="/neuropsychiatrist">Dr. Savita Patel</Link></h5>
                                        <div className="designation"><b>MBBS, MD (Mental Health & Neuropsychiatricand Addiction Specialist)</b></div>

                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <div className="about-one_button">
                                                <Link to="/neuropsychiatrist" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>

                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Subhashini Mishra.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><Link to="/gynaecology">Dr. Subhashini Mishra</Link></h5>
                                        <div className="designation"><b>MBBS, (Obstetrics & Gynecology)</b></div>
                                        <br />
                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <div className="about-one_button">
                                                <Link to="/gynaecology" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>
                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Priyanka Kushwaha.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><Link to="/paediatrics">Dr. Priyanka Kushwaha</Link></h5>
                                        <div className="designation"><b>MBBS, MS, MCH Pediatric Surgeon (Gold Medalist)</b></div>
                                        <br />
                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <div className="about-one_button">
                                                <Link to="/paediatrics" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>
                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Tankeshwar Patel.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><Link to="/paediatrics">Dr. Tankeshwar Patel</Link></h5>
                                        <div className="designation"><b> MBBS, MD ( Neonatologist and Pediatrician ) </b></div>
                                        <br />

                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <div className="about-one_button">
                                                <Link to="/paediatrics" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>

                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Radhe shyam.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><Link to="/dr-radhe-shyam">Dr. Radhe Shyam</Link></h5>
                                        <div className="designation"><b> Physiotherapist Specialist </b></div>

                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <br />
                                            <br />
                                            <br />
                                            <div className="about-one_button">
                                                <Link to="/dr-radhe-shyam" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>
                        <div className="team-block-two col-lg-3 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                                <div className="image">
                                    <img src="assets/img/Dr. Himanshu Singh.webp" alt />
                                </div>
                                <div className="lower-content">
                                    <div className="content">
                                        <h5><Link to="/dental">Dr. Himanshu Singh</Link></h5>
                                        <div className="designation m"><b>B.D.S. (Oral & Dental Surgeon)</b></div>
                                        <br />
                                        <br />
                                        <ul className="social-box">
                                            <li className="facebook"><a to="#" className="fa fa-facebook-f" /></li>
                                            <li className="instagram"><a to="#" className="fa fa-instagram" /></li>
                                            <li className="twitter"><a to="#" className="fa fa-youtube" /></li>
                                            {/* <li className="linkedin"><a to="#" className="fa fa-linkedin" /></li> */}
                                            <div className="about-one_button">
                                                <Link to="/dental" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "80px", borderRadius: "90px" }} >
                                                        <span style={{ borderRadius: "90px" }} className="text-one">View Profile</span>
                                                        <span className="text-two">View Profile</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </ul>
                                    </div>
                                    {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

        </>
    )
}

export default OurDoctor